/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { VivaLiteScanStrictHttpResponse } from '../../viva-lite-scan-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FileDownloadModel } from '../../models/file-download-model';

export interface AdminSystemIdentifierAccessCodeReportIdGet$Params {

/**
 * The unique identifier of the access code
 */
  id: string;

/**
 * The start date for the report period
 */
  fromDate?: string;

/**
 * The end date for the report period
 */
  toDate?: string;
}

export function adminSystemIdentifierAccessCodeReportIdGet(http: HttpClient, rootUrl: string, params: AdminSystemIdentifierAccessCodeReportIdGet$Params, context?: HttpContext): Observable<VivaLiteScanStrictHttpResponse<FileDownloadModel>> {
  const rb = new RequestBuilder(rootUrl, adminSystemIdentifierAccessCodeReportIdGet.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.query('fromDate', params.fromDate, {});
    rb.query('toDate', params.toDate, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as VivaLiteScanStrictHttpResponse<FileDownloadModel>;
    })
  );
}

adminSystemIdentifierAccessCodeReportIdGet.PATH = '/Admin/SystemIdentifierAccessCodeReport/{id}';
